import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { collection, onSnapshot } from 'firebase/firestore'
import { signInAnonymously, onAuthStateChanged } from 'firebase/auth'
import { db, auth } from '../../firebase/firebase'
import { t } from '../../components/i18n/i18n'
import LikeButton from '../../components/LikeButton'
import back from "../../assets/images/elements/library.jpg"
import { articlesData } from "../../assets/data/articles"
import '../../assets/css/pages.css'

export const Resources = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const articlesPerPage = 6
  const [anonUid, setAnonUid] = useState(null)
  const [articleCounts, setArticleCounts] = useState({})

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) setAnonUid(user.uid)
      else { const cred = await signInAnonymously(auth); setAnonUid(cred.user.uid) }
    })
    return unsub
  }, [])

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'articles'), snap => {
      const counts = {}
      snap.docs.forEach(d => { counts[d.id] = d.data().likesCount || 0 })
      setArticleCounts(counts)
    })
    return unsub
  }, [])

  const handleSearch = event => {
    setSearchTerm(event.target.value)
    setCurrentPage(1)
  }

  const filteredArticles = articlesData.filter((article) => {
    if (!searchTerm.trim()) return true
    const searchWords = searchTerm.trim().toLowerCase().split(/\s+/)
    const translatedTitle  = t(article.titleKey)?.toLowerCase()       || ''
    const translatedAuthor = t(article.authorKey)?.toLowerCase()      || ''
    const translatedDesc   = t(article.descriptionKey)?.toLowerCase() || ''
    const allKeywords = [...(article.keywords_ua || []), ...(article.keywords_en || [])].map(k => k.toLowerCase())
    return searchWords.every(word =>
      translatedTitle.includes(word) ||
      translatedAuthor.includes(word) ||
      translatedDesc.includes(word) ||
      allKeywords.some(k => k.includes(word))
    )
  })

  const indexOfLast    = currentPage * articlesPerPage
  const currentArticles = filteredArticles.slice(indexOfLast - articlesPerPage, indexOfLast)
  const totalPages      = Math.ceil(filteredArticles.length / articlesPerPage)

  return (
    <section className='blog'>
      <div className='container_100'>

        <div className='page-hero'>
          <img src={back} alt='' />
          <div className='page-hero__overlay' />
          <h1 className='page-hero__title'>{t("resourcesHeader")}</h1>
        </div>

        <div className='container boxItems'>
          <div className='page-search-wrap'>
            <input
              type="text"
              placeholder={t("search")}
              value={searchTerm}
              onChange={handleSearch}
              className='page-search-input'
            />
          </div>

          <div className='res-grid'>
            {currentArticles.map((article) => (
              <div className='res-card' key={article.id}>

                <div className='res-card__img-wrap'>
                  <Link to={article.url}>
                    <img src={article.img} alt={t(article.titleKey)} className='res-card__img' />
                  </Link>
                </div>

                <div className='res-card__details'>
                  <div>
                    <Link to={article.url} style={{ textDecoration: 'none' }}>
                      <h3 className='menuColor res-card__title'>{t(article.titleKey)}</h3>
                    </Link>
                    <p className='res-card__author'><em>{t(article.authorKey)}</em></p>
                    <p className='res-card__desc'>{t(article.descriptionKey)}</p>
                  </div>
                  <div className='res-card__footer'>
                    <Link to={article.url} className='readMore res-card__read-more'>
                      {t("resourceReadMore")} →
                    </Link>
                    <LikeButton
                      itemId={article.id}
                      count={articleCounts[article.id] || 0}
                      anonUid={anonUid}
                      collectionName='articles'
                    />
                  </div>
                </div>

              </div>
            ))}
          </div>

          {filteredArticles.length === 0 && <div className='res-empty'>Нічого не знайдено</div>}

          {totalPages > 1 && (
            <div className='res-pagination'>
              <button
                className='res-page-btn'
                onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
              >←</button>

              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i + 1}
                  className={`res-page-btn${currentPage === i + 1 ? ' res-page-btn--active' : ''}`}
                  onClick={() => setCurrentPage(i + 1)}
                >{i + 1}</button>
              ))}

              <button
                className='res-page-btn'
                onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                disabled={currentPage === totalPages}
              >→</button>
            </div>
          )}

        </div>
      </div>
    </section>
  )
}
